<template>
  <el-row>
    <el-col :span="9">
      <basic-container>
        <avue-crud :option="user.option"
                   :table-loading="user.loading"
                   :data="user.data"
                   :page.sync="user.page"
                   :permission="permissionList"
                   :before-open="beforeOpenUser"
                   v-model="user.form"
                   ref="usercrud"
                   @row-save="rowSaveUser"
                   @row-update="rowUpdateUser"
                   @row-del="rowDelUser"
                   @search-change="searchChangeUser"
                   @size-change="sizeChangeUser"
                   @current-change="currentChangeUser"
                   @on-load="onLoadUser">
<!--
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @refresh-change="onLoad"
                   -->
          <template slot-scope="scope" slot="menu">
            <el-button
              type="text"
              size="small"
              icon="el-icon-plus"
              @click="addTopic(scope.row)"
            >添加主题
            </el-button>
          </template>
        </avue-crud>
      </basic-container>
    </el-col>
    <el-col :span="15">
      <basic-container>
        <avue-crud :option="acl.option"
                   :table-loading="acl.loading"
                   :data="acl.data"
                   :page.sync="acl.page"
                   :permission="permissionList"
                   :before-open="beforeOpenAcl"
                   v-model="acl.form"
                   ref="aclcrud"
                   @row-save="rowSaveAcl"
                   @row-update="rowUpdateAcl"
                   @row-del="rowDelAcl"
                   @search-change="searchChangeAcl"
                   @size-change="sizeChangeAcl"
                   @current-change="currentChangeAcl"
                   @on-load="onLoadAcl">
        </avue-crud>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
  import {getUserList, addUser,removeUser, updateUser } from '@/views/v4ward/park/mqtt/mqttuserapi';
  import {getAclList, addAcl,removeAcl, updateAcl } from '@/views/v4ward/park/mqtt/mqttaclapi';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        user: {
          formType: 'add',
          form: {},
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0,
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 30,
            tip: false,
            searchShow: true,
            searchMenuSpan: 6,
            border: true,
            index: true,
            viewBtn: true,
            selection: false,
            dialogClickModal: false,
            dialogWidth: 500,
            align: 'center',
            menuWidth: 220,
            refreshBtn: false,
            columnBtn: false,
            emptyBtn: false,
            column: [
              {
                label: '车场编号',
                prop: 'username',
                search: true,
                searchSpan: 12,
                overHidden: true,
                width: 130,
                span: 24,
                rules: [{
                  required: true,
                  message: '请输入车场编号',
                  trigger: 'change',
                }],
              },
              {
                label: '连接密码',
                prop: 'password',
                overHidden: true,
                span: 24,
                rules: [{
                  required: true,
                  message: '请输入连接密码',
                  trigger: 'change',
                }],
              },
            ],
          },
          data: [],
        },
        acl: {
          formType: 'add',
          form: {
            username: '',
          },
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0,
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 30,
            tip: false,
            searchShow: true,
            searchMenuSpan: 6,
            border: true,
            index: true,
            viewBtn: true,
            selection: false,
            dialogClickModal: false,
            dialogWidth: 700,
            align: 'center',
            menuWidth: 160,
            refreshBtn: false,
            columnBtn: false,
            addBtn: false,
            column: [
              {
                label: '车场编号',
                prop: 'username',
                search: true,
                searchSpan: 6,
                overHidden: true,
                width: 130,
                addDisabled: true,
                editDisabled: true,
                rules: [{
                  required: true,
                  message: '请输入车场编号',
                  trigger: 'change',
                }],
              },
              {
                label: '物业类型',
                prop: 'wyType',
                hide: true,
                editDisplay: false,
                viewDisplay: false,
                type: 'select',
                search: true,
                searchSpan: 6,
                dicData: [
                  {label: '长江物业',value: 'cjwy'},
                  {label: '宜昌本色',value: 'ycbs'},
                  {label: '更新物业',value: 'gxwy'},
                  {label: '公共车场',value: 'park'},
                  {label: '公共车场演示',value: 'demo'},
                  {label: '长江物业测试',value: 'cjwytest'},
                  {label: '长江物业开发',value: 'cjwydev'},
                ],
                rules: [{
                  required: true,
                  message: '请选择消息权限',
                  trigger: 'change',
                }],
              },
              {
                label: '道闸类型',
                prop: 'equType',
                hide: true,
                editDisplay: false,
                viewDisplay: false,
                type: 'select',
                search: true,
                searchSpan: 6,
                dicData: [
                  {label: '捷顺道闸',value: '3'},
                  {label: '唯阜德道闸',value: '4'},

                ],
                rules: [{
                  required: true,
                  message: '请选择消息权限',
                  trigger: 'change',
                }],
              },
              {
                label: '岗亭编号',
                prop: 'sentryBoxCode',
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                rules: [{
                  required: true,
                  message: '请输入岗亭编号',
                  trigger: 'change',
                }],
              },
              {
                label: '控制权限',
                prop: 'allow',
                type: 'select',
                width: 70,
                defaultValue: 1,
                search: true,
                searchSpan: 6,
                dicData: [
                  {label: '允许',value: 1},
                  {label: '拒绝',value: 0},
                ],
                rules: [{
                  required: true,
                  message: '请选择控制权限',
                  trigger: 'change',
                }],
              },
              {
                label: '消息权限',
                prop: 'access',
                type: 'select',
                width: 80,
                defaultValue: 1,
                search: true,
                searchSpan: 6,
                dicData: [
                  {label: '订阅',value: 1},
                  {label: '发布',value: 2},
                ],
                rules: [{
                  required: true,
                  message: '请选择消息权限',
                  trigger: 'change',
                }],
              },
              {
                label: '客户端ID',
                prop: 'clientid',
                span: 24,
                search: true,
                searchSpan: 6,
                overHidden: true,
                rules: [{
                  required: true,
                  message: '请输入连接密码',
                  trigger: 'change',
                }],
              },
              {
                label: '消息主题',
                prop: 'topic',
                overHidden: true,
                span: 24,
                search: true,
                searchSpan: 6,
                rules: [{
                  required: true,
                  message: '请输入消息主题',
                  trigger: 'change',
                }],
              },
              {
                label: '备注信息',
                prop: 'remark',
                width: 120,
                overHidden: true,
                search: true,
                searchSpan: 6,
                maxlength: 10,
                rules: [{
                  required: true,
                  message: '请输入备注信息',
                  trigger: 'change',
                }],
              },
            ],
          },
          data: [],
        },
      };
    },
    watch: {
      'user.form.username'() {
        if(this.user.formType === 'add'){
          if (this.vdui.isNotEmpty(this.user.form.username)) {
            this.user.form.password = '123456' + this.user.form.username;
          }else {
            this.user.form.password = '';
          }
        }
      },
      'acl.form.wyType'(){
        this.checkAndChangeClientTopic();
      },
      'acl.form.equType'(){
        this.sentryBoxCodeVisibleChange();
        this.checkAndChangeClientTopic();
      },
      'acl.form.access'(){
        this.checkAndChangeClientTopic();
      },
      'acl.form.sentryBoxCode'(){
        this.checkAndChangeClientTopic();
      }
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: true,
          viewBtn: false,
          delBtn: true,
          editBtn: true,
        };
      },
/*      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },*/
    },
    methods: {
      sentryBoxCodeVisibleChange(){
        console.log(this.acl.form.equType === '4');
        var sentryBoxColumn = this.findObject(this.acl.option.column, 'sentryBoxCode');
        if(this.acl.form.equType === '4'){
          sentryBoxColumn.addDisplay = true;
        }else{
          sentryBoxColumn.addDisplay = false;
        }
      },
      checkAndChangeClientTopic(){
        var wyType = this.acl.form.wyType;
        var equType = this.acl.form.equType;
        var subType = this.acl.form.access;
        if(this.vdui.isEmpty(wyType) || this.vdui.isEmpty(equType) || this.vdui.isEmpty(subType)){
          return;
        }
        var clientSuffix = '' ;
        var messageDirection = '/prk/wy/';
        if(subType === 1){
          clientSuffix = '_sub';
          messageDirection = '/wy/prk/';
        }else if(subType === 2){
          clientSuffix = '_pub';
        }
        if(equType === '4' &&  this.vdui.isEmpty(this.acl.form.sentryBoxCode)){
          return;
        }
        var equTypeName = 'jielink';
        if(equType === '4'){
          equTypeName = 'v4ward';
          if(this.vdui.isEmpty(this.acl.form.sentryBoxCode)){
            return;
          }else{
            clientSuffix = '_' + this.acl.form.sentryBoxCode;
          }
        }
        this.acl.form.clientid = wyType + '_' + equTypeName +'_client_' + this.acl.form.username + clientSuffix;
        this.acl.form.topic = wyType +'/' + equTypeName + messageDirection + this.acl.form.username;
      },
      onLoadAcl(page) {
        page = page || this.acl.page;
        this.acl.loading = true;
        getAclList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.acl.query),
        ).then(({ data }) => {
          this.acl.page.total = data.total;
          this.acl.data = data.records;
          this.acl.loading = false;
          this.selectionClearAcl();
        });
      },
      selectionClearAcl() {
        this.acl.selectionList = [];
        this.$refs.aclcrud.toggleSelection();
      },
      beforeOpenAcl(done, type) {
        this.acl.formType = type;
        if('add' === type){
          this.acl.form = {};
        }else{

        }
        done();
      },
      rowSaveAcl(row, done, loading) {
        addAcl(row).then(() => {
          this.onLoadAcl();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdateAcl(row, index, done, loading) {
        updateAcl(row).then(() => {
          this.onLoadAcl();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDelAcl(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return removeAcl({ id: row.id });
          })
          .then(() => {
            this.onLoadAcl();
            this.$message.success('操作成功!');
          });
      },
      searchChangeAcl(params, done) {
        this.acl.query = params;
        this.acl.page.currentPage = 1;
        this.onLoadAcl();
        done();
      },
      sizeChangeAcl(pageSize) {
        this.acl.page.pageSize = pageSize;
      },
      currentChangeAcl(currentPage) {
        this.acl.page.currentPage = currentPage;
      },

      ///////////////////////////////////////////////////////////  user  //////////////////////////////////////////
      onLoadUser(page) {
        page = page || this.user.page;
        this.user.loading = true;
        getUserList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.user.query),
        ).then(({ data }) => {
          this.user.page.total = data.total;
          this.user.data = data.records;
          this.user.loading = false;
          this.selectionClearUser();
        });
      },
      selectionClearUser() {
        this.user.selectionList = [];
        this.$refs.usercrud.toggleSelection();
      },
      beforeOpenUser(done, type) {
        this.user.formType = type;
        if('add' === type){
          this.user.form = {};
        }else{

        }
        done();
      },
      rowSaveUser(row, done, loading) {
        addUser(row).then(() => {
          this.onLoadUser();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdateUser(row, index, done, loading) {
        updateUser(row).then(() => {
          this.onLoadUser();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDelUser(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return removeUser({ id: row.id });
          })
          .then(() => {
            this.onLoadUser();
            this.$message.success('操作成功!');
          });
      },
      searchChangeUser(params, done) {
        this.user.query = params;
        this.user.page.currentPage = 1;
        this.onLoadUser();
        done();
      },
      sizeChangeUser(pageSize) {
        this.user.page.pageSize = pageSize;
      },
      currentChangeUser(currentPage) {
        this.user.page.currentPage = currentPage;
      },

      addTopic(row){
        this.$refs.aclcrud.rowAdd();
        this.acl.form.username = row.username;
        this.acl.form.allow = 1;
      },
      /*rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        } else if ('add' === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      },*/
    },
  };
</script>

<style>
</style>
